__turbopack_context__.v({
  "description": "Section-module-scss-module__PVCzVq__description",
  "fade-in": "Section-module-scss-module__PVCzVq__fade-in",
  "header": "Section-module-scss-module__PVCzVq__header",
  "headingIcon": "Section-module-scss-module__PVCzVq__headingIcon",
  "headingLink": "Section-module-scss-module__PVCzVq__headingLink",
  "headingText": "Section-module-scss-module__PVCzVq__headingText",
  "no-transform": "Section-module-scss-module__PVCzVq__no-transform",
  "rotate": "Section-module-scss-module__PVCzVq__rotate",
  "section": "Section-module-scss-module__PVCzVq__section",
});
